import { EncounterDto } from "@/api/entities/encounters";
import { EncounterState } from "./types";

import { defineStore } from "pinia";

export const useEncounterStore = defineStore("package", {
  state: (): EncounterState => ({
    loaded: false,
    encounters: []
  }),
  actions: {
    setState(encounters: EncounterDto[]) {
      const sortedEncounters = encounters;
      this.encounters = sortedEncounters.sort(
        (a, b) => +new Date(a.created) - +new Date(b.created)
      );
      this.loaded = true;
      return sortedEncounters;
    },
    updateEncounter(encounter: EncounterDto) {
      const index = this.encounters.findIndex(t => t.id === encounter.id);
      if (index >= 0) {
        this.encounters[index] = encounter;
      } else {
        this.encounters.push(encounter);
      }
    }
  }
});
